/**
 * NotificationGetReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * NotificationGetReq
 */
export interface NotificationGetReq {
  /** 通知ID，逗号分隔 */
  id: string
}

/**
 * NotificationGetReq Schema
 */
export const NotificationGetReqSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '通知ID，逗号分隔',
      format: 'string',
      type: 'string',
      label: '通知ID',
    },
  },
  required: ['id'],
  type: 'object',
}
